import React from 'react';
import PropTypes from 'prop-types';
import {withStore, withScreenCheck} from '../hoc';
import Navbar from '../components/Navbar';
import Header from '../components/Header';
import Body from '../components/Body';
import Footer from '../components/Footer';
import {Card} from '../components/Cards';

/**
 * EmploiPage
 */
class EmploiPage extends React.Component {
  static displayName = 'EmploiPage';
  static propTypes = {
    stores: PropTypes.object.isRequired,
    currentPage: PropTypes.object.isRequired,
    screen: PropTypes.string.isRequired,
  };

  static defaultProps = {};

  /**
   * @override
   */
  render() {
    return (
      <div className="EmploiPage">
        <Navbar {...this.props} />
        <Header
          {...this.props}
          images={[
            this.props.screen === 'desktop'
              ? this.props.currentPage.heroImage()
              : this.props.currentPage.heroMobileImage(),
          ]}
        >
          {this.props.currentPage.heroCaption()}
        </Header>
        <Body {...this.props}>
          <Card title="Emplois" className="full" {...this.props}>
            {this.props.currentPage.Content}
          </Card>
          {this.props.currentPage
            .cards()
            .map(link => (
              <Card
                card={link}
                key={link.ID}
                className="full image-right"
                portrait={true}
                {...this.props}
              />
            ))}
        </Body>
        <Footer {...this.props} />
      </div>
    );
  }
}
export default withStore(withScreenCheck(EmploiPage));



// WEBPACK FOOTER //
// ./src/pages/EmploiPage.js